import { useEditorStore } from '@/features/editor/stores/mobx/editor-store';
import { observer } from 'mobx-react-lite';
import React from 'react';
import { SelectField } from '@/components/select-field';
import { ESDEC_ROOF_STEEL_TYPE } from '../esdec-types';
import { FormattedMessage, useIntl } from 'react-intl';

export const EsdecSteelTypeInput = observer(function EsdecSteelTypeInput({
  surfaceId
}: {
  surfaceId: string;
}) {
  const store = useEditorStore();
  const intl = useIntl();
  const { surfacesEsdec } = store;

  const surfaceEsdec = surfacesEsdec.surfaces[surfaceId];

  if (!surfaceEsdec) {
    return <React.Fragment />;
  }

  const steelTypeOptions = ESDEC_ROOF_STEEL_TYPE.steelType.map((steelType) => ({
    label: steelType,
    value: steelType
  }));

  return (
    <SelectField
      isDisabled={surfaceEsdec.isRoofFinalized}
      label={intl.formatMessage({
        defaultMessage: 'Steel Type',
        id: 'mrZ5E6'
      })}
      placeholder={<FormattedMessage defaultMessage="Select Steel Type" id="jw0YjT" />}
      name="steelType"
      options={steelTypeOptions}
      onChange={(value) => {
        if (value) {
          surfaceEsdec.updateSteelType(value.value);
        }
      }}
      value={steelTypeOptions.find((steelTypeOption) => steelTypeOption.value === surfaceEsdec.steelType)}
    />
  );
});
